<template>
    <div class="entiretyClass">
        <common-left @hasSubMenu="hasSubMenu" ref="menuRef"></common-left>
        <div class="content">
            <common-top @messageLog="messageLog"></common-top>
            <div class="commonCenter" :style="hasSubMenuValue?'padding-left:100px':'padding-left:0'">
                <el-scrollbar style="height: 100%;">
                    <router-view  @hompageLog="hompageLog"></router-view>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
    import commonLeft from './layout/common_left'
    import commonTop from './layout/common_top'
    export default {
        name: "index",
        data(){
            return{
                hasSubMenuValue:false
            }
        },
        components: {
            commonLeft,
            commonTop
        },
        created(){
          this.childBarBar()
        },
        methods: {
          childBarBar(){
            if (location.href.indexOf('demand') > 0) {
              this.resetSetItem('menuActiveId','71')
              this.$refs.menuRef.routeHandle('71')
            }else if(location.href.indexOf('printOrderList') > 0){
              this.resetSetItem('menuActiveId','100')
              this.$refs.menuRef.routeHandle('100')
            }else if(location.href.indexOf('severOrderList') > 0){
              this.resetSetItem('menuActiveId','104')
              this.$refs.menuRef.routeHandle('104')
            }else if(location.href.indexOf('mallOrderList') > 0){
                this.resetSetItem('menuActiveId','101')
                this.$refs.menuRef.routeHandle('101')
            }else if(location.href.indexOf('activeJoin') > 0){
                this.resetSetItem('menuActiveId','80')
                this.$refs.menuRef.routeHandle('80')
            }else if(location.href.indexOf('modelOrderDetail') > 0){
                this.resetSetItem('menuActiveId','103')
                this.$refs.menuRef.routeHandle('103')
            }else if(location.href.indexOf('integralOrderList') > 0){
                this.resetSetItem('menuActiveId','106')
                this.$refs.menuRef.routeHandle('106')
            }

          },
          hasSubMenu(val){
              this.hasSubMenuValue = val
          },
          // 消息定位
          messageLog(){
              //消息菜单的id
              this.resetSetItem('menuActiveId','54')
              this.$refs.menuRef.routeHandle('54')
          },
          // 定位
          hompageLog(type){
              console.log('hfakjs',type );
              //收货地址
              if(type == 'adr'){
                  this.resetSetItem('menuActiveId','12')
                  this.$refs.menuRef.routeHandle('12')
              }else if (type == 'coll'){
                  // / 全部收藏
                  this.resetSetItem('menuActiveId','30')
                  this.$refs.menuRef.routeHandle('30')
              }else if (type == 'des'){
                  // 全部设计师
                  this.resetSetItem('menuActiveId','41')
                  this.$refs.menuRef.routeHandle('41')
              }else if (type == 'store'){
                  // 全部店铺
                  this.resetSetItem('menuActiveId','40')
                  this.$refs.menuRef.routeHandle('40')
              }else if (type == 'brow'){
                  // 全部足迹
                  this.resetSetItem('menuActiveId','60')
                  this.$refs.menuRef.routeHandle('60')
              }else if (type == 'allOrder'){
                  // 全部足迹
                  this.resetSetItem('menuActiveId','100')
                  this.$refs.menuRef.routeHandle('100')
              }else if (type == 'deg'){
                  // 设计订单
                  this.resetSetItem('menuActiveId','102')
                  this.$refs.menuRef.routeHandle('102')
              }else if (type == 'storOrder'){
                  // 商城订单
                  this.resetSetItem('menuActiveId','101')
                  this.$refs.menuRef.routeHandle('101')
              }else if (type == 'sercerOr'){
                  // 服务订单
                  this.resetSetItem('menuActiveId','104')
                  this.$refs.menuRef.routeHandle('104')
              }else if (type == 'modelOr'){
                  // 模型订单
                  this.resetSetItem('menuActiveId','103')
                  this.$refs.menuRef.routeHandle('103')
              }else if (type == 'softwareOr'){
                  // 软件订单
                  this.resetSetItem('menuActiveId','105')
                  this.$refs.menuRef.routeHandle('105')
              }

          }
      }
    }
</script>

<style scoped lang="less">
    .entiretyClass{
        width: 100%;
        height: 100%;
        .content{
            margin-left: 90px;
            height: 100%;
            background: #fff;
            border-top-left-radius: 20px;
            position: relative;
            .commonCenter{
                width: 100%;
                height: 100%;
                padding-top: 60px;
                /deep/.el-scrollbar__wrap {
                    overflow-x: hidden;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/index.vue